import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as ___EmotionJSX } from "@emotion/react";
const StyledImage = /*#__PURE__*/_styled(({
  src
}) => ___EmotionJSX("img", {
  src: src || '',
  role: "presentation"
}), {
  target: "eeuykvb0",
  label: "StyledImage"
})(process.env.NODE_ENV === "production" ? {
  name: "waguu7",
  styles: "display:block;max-width:100%;height:auto"
} : {
  name: "waguu7",
  styles: "display:block;max-width:100%;height:auto/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function StyledImageAsset({
  getAsset,
  value,
  field
}) {
  const [asset, setAsset] = useState(null);
  useEffect(() => {
    if (!value) {
      setAsset(null);
      return;
    }
    if (typeof File !== 'undefined' && value instanceof File) {
      const objectUrl = URL.createObjectURL(value);
      setAsset(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
    const newAsset = getAsset(value, field);
    setAsset(newAsset);
  }, [value, field, getAsset]);
  return asset ? ___EmotionJSX(StyledImage, {
    src: asset
  }) : null;
}
function ImagePreviewContent(props) {
  const {
    value,
    getAsset,
    field
  } = props;
  if (Array.isArray(value) || List.isList(value)) {
    return value.map((val, index) => ___EmotionJSX(StyledImageAsset, {
      key: index,
      value: val,
      getAsset: getAsset,
      field: field
    }));
  }
  return ___EmotionJSX(StyledImageAsset, props);
}
function ImagePreview(props) {
  return ___EmotionJSX(WidgetPreviewContainer, null, props.value ? ___EmotionJSX(ImagePreviewContent, props) : null);
}
ImagePreview.propTypes = {
  getAsset: PropTypes.func.isRequired,
  value: PropTypes.node
};
export default ImagePreview;